<template>
    <div class="home" v-loading="loading">
        <div class="swiper-slide">
            <!-- <img class="page5-tu1" src="../assets/img/index.1.png" style="height:21.4rem;" id="FadeOut" />
            <img class="page5-tu3" src="../assets/img/index.2.jpg" style="height:8rem;" id="FadeOut1" /> -->

            <div class="page">
                <h3 v-if="language == 'ZH'">{{ $t('h.CompanyName')}}</h3>
                <h3 v-else style="letter-spacing: 0;">{{ $t('h.CompanyName')}}</h3>
                <p v-if="language == 'ZH'">{{ $t('h.Service')}}</p>
                <p v-else style="letter-spacing: 0;">{{ $t('h.Service')}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HelloWorld",
    data() {
        return {
            loading: true,
            language:localStorage.getItem("lang") || "ZH"
        };
    },
    created() {},

    mounted() {
        this.loading = false;
        if (localStorage.getItem("showAnimation")) {
            var frame1 = document.getElementById("FadeOut");
            frame1.className = "FadeInFrame1";
            var frame2 = document.getElementById("FadeOut1");
            frame2.className = "FadeInFrame1";
            var frame = document.getElementById("fadeIn");
            frame.className = "page FadeInFrame2";
            return;
        }
        this.language = localStorage.getItem("lang") || "ZH"
        this.FadeOutLinkClick();
        this.FadeOutLinkClick1();
        this.FadeInLinkClick();
    },
    methods: {
        FadeOutLinkClick() {
            setTimeout(() => {
                var frame = document.getElementById("FadeOut");
                frame.className = "fadeout page5-tu1";
            }, 1000);
        },
        FadeOutLinkClick1() {
            setTimeout(() => {
                var frame = document.getElementById("FadeOut1");
                frame.className = "fadeout page5-tu3";
            }, 1000);
        },
        FadeInLinkClick() {
            setTimeout(() => {
                var frame = document.getElementById("fadeIn");
                frame.className = "page fadein";
                localStorage.setItem("showAnimation", false);
            }, 2000);
        },
    },
};
</script>

<style  scoped>
.home {
}
.swiper-slide {
    margin-top: 150px;
    font-size: 24px;
    text-align: center;
    line-height: 170px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    height: 95% !important;

}
.swiper-slide .page {
    text-align: center;
    overflow: hidden;
}
.swiper-slide .page h3 {
    font-size: 3.3rem;
    letter-spacing: 1.5rem;
}
.swiper-slide .page p {
    font-size: 2.5rem;
    letter-spacing: 0.5rem;
}

/* 图片动画 */

.page5-tu1 {
    position: absolute;
    width: REM(480);
    height: REM(206);
    left: 23%;
    opacity: 1;
}

.page5-tu3 {
    position: absolute;
    width: REM(480);
    height: REM(206);
    left: 52%;
    opacity: 1;
}

.page5-tu1 {
    bottom: REM(778);
}

.page5-tu3 {
    bottom: REM(314);
}

.fadeout {
    -webkit-transition: all 7s;
    -moz-transition: all 7s;
    -ms-transition: all 7s;
    -o-transition: all 7s;
    transition: all 7s;
    opacity: 0;
}
.FadeInFrame {
    opacity: 0;
}
.FadeInFrame1 {
    display: none;
}
.FadeInFrame2 {
    display: block;
    opacity: 1;
}
.fadein {
    -webkit-transition: all 7s;
    -moz-transition: all 7s;
    -ms-transition: all 7s;
    -o-transition: all 7s;
    transition: all 7s;
    opacity: 1;
}
</style>